/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSubscriptionDto } from '../models/CreateSubscriptionDto';
import type { CustomerSubscriptionDtoPaginationResultDto } from '../models/CustomerSubscriptionDtoPaginationResultDto';
import type { PaidPeriodTypeDto } from '../models/PaidPeriodTypeDto';
import type { ProductDto } from '../models/ProductDto';
import type { RedemptionRequestDto } from '../models/RedemptionRequestDto';
import type { SubscriptionDto } from '../models/SubscriptionDto';
import type { SubscriptionStatus } from '../models/SubscriptionStatus';
import type { SubscriptionsTotalPaidDto } from '../models/SubscriptionsTotalPaidDto';
import type { SubscriptionTransactionDtoPaginationResultDto } from '../models/SubscriptionTransactionDtoPaginationResultDto';
import type { UpdateSubscriptionAutoRenewDto } from '../models/UpdateSubscriptionAutoRenewDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class EarnService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ProductDto Success
     * @throws ApiError
     */
    public getApiEarnProducts(): CancelablePromise<Array<ProductDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/earn/products',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SubscriptionDto Created
     * @throws ApiError
     */
    public postApiEarnSubscriptions(
        requestBody?: CreateSubscriptionDto,
    ): CancelablePromise<SubscriptionDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/earn/subscriptions',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param page
     * @param count
     * @param subscriptionStatus
     * @returns CustomerSubscriptionDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getApiEarnSubscriptions(
        page: number = 1,
        count: number = 10,
        subscriptionStatus?: SubscriptionStatus,
    ): CancelablePromise<CustomerSubscriptionDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/earn/subscriptions',
            query: {
                'page': page,
                'count': count,
                'subscriptionStatus': subscriptionStatus,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param subscriptionId
     * @param requestBody
     * @returns SubscriptionDto Success
     * @throws ApiError
     */
    public putApiEarnSubscriptionsAutoRenewEnabled(
        subscriptionId: number,
        requestBody?: UpdateSubscriptionAutoRenewDto,
    ): CancelablePromise<SubscriptionDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/earn/subscriptions/{subscriptionId}/auto-renew-enabled',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param subscriptionId
     * @param requestBody
     * @returns SubscriptionDto Created
     * @throws ApiError
     */
    public postApiEarnSubscriptionsRedemption(
        subscriptionId: number,
        requestBody?: RedemptionRequestDto,
    ): CancelablePromise<SubscriptionDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/earn/subscriptions/{subscriptionId}/redemption',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param subscriptionId
     * @param page
     * @param count
     * @returns SubscriptionTransactionDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getApiEarnSubscriptionsTransactions(
        subscriptionId: number,
        page: number = 1,
        count: number = 10,
    ): CancelablePromise<SubscriptionTransactionDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/earn/subscriptions/{subscriptionId}/transactions',
            path: {
                'subscriptionId': subscriptionId,
            },
            query: {
                'page': page,
                'count': count,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param period
     * @returns SubscriptionsTotalPaidDto Success
     * @throws ApiError
     */
    public getApiEarnSubscriptionsTotalPaid(
        period?: PaidPeriodTypeDto,
    ): CancelablePromise<SubscriptionsTotalPaidDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/earn/subscriptions/total-paid',
            query: {
                'period': period,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
}
